import { Component, OnInit } from '@angular/core';
import * as countryData from 'country-data';
import { Ng1LiveChatService } from '../../shared/ng1/ng1-live-chat.service';
import { MatDialogRef } from '@angular/material/dialog';
import { freePortingCountryCodes } from './free-porting';

@Component({
  selector: 'cc-free-porting-dialog',
  templateUrl: './free-porting-dialog.component.html',
  styleUrls: ['./free-porting-dialog.component.scss']
})
export class FreePortingDialogComponent implements OnInit {
  constructor(
    public ng1LiveChatService: Ng1LiveChatService,
    public dialogRef: MatDialogRef<FreePortingDialogComponent>
  ) {}

  ngOnInit() {}

  getCountries() {
    return countryData.callingCountries.all
      .filter(data => freePortingCountryCodes.includes(data.alpha2))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  contactSupport() {
    this.ng1LiveChatService.contactSupport();
  }

  close() {
    this.dialogRef.close();
  }
}
